<template>
  <a-modal
    :title='title'
    :width='600'
    :visible='visible'
    :confirmLoading='confirmLoading'
    @ok='handleOk'
    @cancel='handleCancel'
    cancelText='关闭'
    wrapClassName='ant-modal-cust-warp'
    style='top:5%;overflow-y: hidden'>

    <a-spin :spinning='confirmLoading'>
      <a-form :form='form'>

        <a-form-item
          :labelCol='labelCol'
          :wrapperCol='wrapperCol'
          label='Banner路径'>
          <a-input placeholder='请输入Banner路径' v-decorator="[ 'payBannerUrl', validatorRules.payBannerUrl]" />
        </a-form-item>

        <a-form-item
          :labelCol='labelCol'
          :wrapperCol='wrapperCol'
          label='渠道名称'>
          <a-input placeholder='请输入渠道名称' v-decorator="[ 'payChannelName', validatorRules.payChannelName]" />
        </a-form-item>

        <a-form-item
          :labelCol='labelCol'
          :wrapperCol='wrapperCol'
          label='渠道'>
          <a-input placeholder='请输入渠道' v-decorator="[ 'payChannel', validatorRules.payChannel]" />
        </a-form-item>

        <a-form-item
          :labelCol='labelCol'
          :wrapperCol='wrapperCol'
          label='排序'>
          <a-input placeholder='请输入排序' v-decorator="[ 'sort', validatorRules.sort]" />
        </a-form-item>

        <a-form-item
          :labelCol='labelCol'
          :wrapperCol='wrapperCol'
          label='包ID'>
          <!--          <a-input placeholder="请输入appSsid" v-decorator="[ 'appSsid', validatorRules.appSsid]" />-->
          <a-select ref='appSsid' @change='setectChange' style='width: 190px' allowClear
                    v-decorator="[ 'appSsid', validatorRules.appSsid]">
            <a-select-option v-for='item in selectedList' :value='item.appssid' :key='item.appName'>{{ item.appName
              }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          :labelCol='labelCol'
          :wrapperCol='wrapperCol'
          label='渠道类型'>
          <a-input placeholder='请输入渠道类型' v-decorator="[ 'channelType', validatorRules.channelType]" />
        </a-form-item>

        <a-form-item
          :labelCol='labelCol'
          :wrapperCol='wrapperCol'
          label='使用类型'>
          <a-select
            mode="multiple"
            style="width: 190px"
            placeholder="请选择"
            allowClear
            v-decorator="['useType']"
          >
            <a-select-option value="">全部</a-select-option>
            <a-select-option value="1">App</a-select-option>
            <a-select-option value="2">H5</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          :labelCol='labelCol'
          :wrapperCol='wrapperCol'
          label='是否重写账号'>
          <a-radio-group v-decorator="['isRewriteNo', { initialValue: '0' }]">
            <a-radio value='0'>否</a-radio>
            <a-radio value='1'>是</a-radio>
          </a-radio-group>
        </a-form-item>


        <a-form-item
          :labelCol='labelCol'
          :wrapperCol='wrapperCol'
          label='跳Web浏览器开关'>
          <a-radio-group
            v-decorator="['browserOpen', { initialValue: '0' }]">
            <a-radio value='0'>关闭</a-radio>
            <a-radio value='1'>开启</a-radio>
          </a-radio-group>
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import { getApplist } from '@/webpublicapi/order'

export default {
  name: 'payChannelInfoModal',
  data() {
    return {
      selectedList: {},
      title: '操作',
      visible: false,
      // roleDisabled: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        payBannerUrl: {
          rules: [
            { required: true, message: '请输入Banner路径!' }
          ]
        },
        payChannelName: {
          rules: [
            { required: true, message: '请输入渠道名称!' }
          ]
        },
        payChannel: {
          rules: [
            { required: true, message: '请输入渠道!' }
          ]
        },
        appSsid: {
          rules: [
            { required: true, message: '请输入appSsid!' }
          ]
        },
        channelType: {
          rules: [
            { required: true, message: '请输入渠道类型!' }
          ]
        },
        sort: {
          rules: [
            { required: true, message: '请输入排序!' }
          ]
        }
      }
    }
  },
  created() {
    getApplist().then(res => {
      if (res.code === 1000) {
        this.selectedList = res.data
        console.log('selectedList---->', this.selectedList)
      } else {

      }
    })
  },
  methods: {
    setectChange(val) {
      console.log('下拉框发生变化啦---》', val)
      if (val) {
        console.log('没选全部')
      } else {
        console.log('选了全部')
      }


    },
    // getApplistfun(){
    //   getApplist().then(res => {
    //     if (res.code === 1000) {
    //       this.selectedList = res.data
    //       console.log('弹框的selectedList', this.selectedList)
    //     } else {
    //
    //     }
    //   })
    //   console.log('加载弹窗的下拉框！！')
    // },
    add() {
      this.edit({})
    },
    edit(record) {
      console.log('点击了编辑！！', record)
      this.form.resetFields()
      this.open()
      this.model = Object.assign({}, record)
      this.model = {
        ...this.model,
        status: this.model.browserOpen != undefined ? '' + this.model.browserOpen : '1',
        isRewriteNo: this.model.isRewriteNo || '0'
      }

      if (this.model.useType) {
        this.model.useType = this.model.useType.split(',')
      } else {
        // 新增：空值默认全选 [1,2]
        this.model.useType = ['1', '2']
      }

      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'payBannerUrl', 'payChannelName', 'payChannel', 'sort', 'appSsid', 'channelType', 'browserOpen','isRewriteNo','useType'))
      })

    },
    open() {
      this.visible = true
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    openLoading() {
      this.confirmLoading = true
    },
    closeLoading() {
      this.confirmLoading = false
    },
    handleOk() {
      console.log('点击了确认按钮！')
      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          let useTypeArr = values.useType || []
          if (useTypeArr.length === 0 || useTypeArr.includes('')) {
            values.useType = '1,2'
          } else {
            values.useType = useTypeArr.join(',')
          }
          let formData = {
            ...values,
            isRewriteNo: values.isRewriteNo || '0'
          }
          this.$emit('ok', formData)

        }
      })
    },
    handleCancel() {
      this.close()
    }
  }
}
</script>

<style scoped>

</style>